import BASE_URL from '@naruto/bgdcms/src/base/url';
import GUEST_PAGE_KEY from '@naruto/bgdcms/src/base/routes/GuestPageKey';
import { Routes } from '@naruto/bgdcms/src/base/routes/types';

const GUEST_URL = BASE_URL.GUEST;

const Guest: Routes = {
  main: [
    {
      id: GUEST_PAGE_KEY.SIGN_IN,
      route: `${GUEST_URL.ROOT_PAGE_SIGN_IN}`,
      component: import('@naruto/bgdcms/src/components/Pages/SignIn'),
      exact: true,
      showInSidebar: false,
      subRoute: [],
      icon: '',
      iconActive: ''
    }
  ]
};

export default Guest;
